module.exports = __webpack_public_path__ + "img/logo.d16c13b5.png";